import { useState, useEffect } from 'react'

// Shared state for the countdown to keep all timers in sync
let globalTimeLeft = 643 // 10 minutes 43 seconds
let listeners: Array<(time: number) => void> = []
let intervalId: NodeJS.Timeout | null = null

const startGlobalTimer = () => {
  if (!intervalId) {
    intervalId = setInterval(() => {
      globalTimeLeft -= 1
      if (globalTimeLeft <= 0) {
        globalTimeLeft = 0
        if (intervalId) clearInterval(intervalId)
      }
      listeners.forEach((listener) => listener(globalTimeLeft))
    }, 1000)
  }
}

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft)

  useEffect(() => {
    listeners.push(setTimeLeft)
    startGlobalTimer()

    return () => {
      listeners = listeners.filter((l) => l !== setTimeLeft)
    }
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return {
    timeLeft,
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isExpired: timeLeft <= 0,
  }
}
